import { KeyboardEvent } from 'react';

/**
 * Fix-32/1, FW-2/7: an Autocomplete that sits inside the surrounding form's
 * own `<form>`, next to a submit button (the receipt's supplier and line
 * pickers, the product registry lookup). Typing a name and pressing Enter
 * before an option is highlighted (or while the search debounce is still
 * pending) falls through to the browser's native "Enter submits the nearest
 * form" behaviour otherwise. `autoHighlight` keeps a real Enter-to-pick
 * working (MUI itself `preventDefault`s that case); this only closes the gap
 * MUI leaves open. Any element: the input's own handler or the Autocomplete
 * root, which the input's keydown bubbles through (`RHFAutocomplete`).
 */
export function preventEnterSubmit(event: KeyboardEvent<Element>): void {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
}
